import { render } from "./ContactsPage.vue?vue&type=template&id=7bd9b9ab&scoped=true"
import script from "./ContactsPage.vue?vue&type=script&lang=js"
export * from "./ContactsPage.vue?vue&type=script&lang=js"

import "./ContactsPage.vue?vue&type=style&index=0&id=7bd9b9ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd9b9ab"]])

export default __exports__